/* Shared video card behavior. Works on every [data-fm-ugcv-card] on the page:
   click to play with sound, click again to pause, starting one card pauses the others,
   the sound button toggles mute, a playing card pauses when it scrolls out of view, and the cover image
   (printed as data-fm-poster) is only loaded when the card is within about 800px of the screen. */
(function () {
  // Several sections load this file on one page. Run the setup once.
  if (window.__pdpVideoLoaded) return;
  window.__pdpVideoLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) return;
        var video = entry.target.querySelector('[data-fm-ugcv-video]');
        if (video && !video.paused) video.pause();
      });
    }, { threshold: 0.2 });
  }

  // Cover images: set the video's poster when the card gets close to the screen. A card that is hidden
  // (display none, like the feature video on phones) never gets close, so its cover is never downloaded.
  function loadCover(video) {
    var src = video.getAttribute('data-fm-poster');
    if (!src) return;
    video.poster = src;
    video.removeAttribute('data-fm-poster');
  }

  var coverIo = null;
  if ('IntersectionObserver' in window) {
    coverIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        coverIo.unobserve(entry.target);
        var v = entry.target.querySelector('[data-fm-ugcv-video]');
        if (v) loadCover(v);
      });
    }, { rootMargin: '800px 0px' });
  }

  function pauseOthers(except) {
    document.querySelectorAll('[data-fm-ugcv-card]').forEach(function (other) {
      if (other === except) return;
      var v = other.querySelector('[data-fm-ugcv-video]');
      if (v && !v.paused) v.pause();
    });
  }

  function init(card) {
    if (card.hasAttribute('data-pdp-ready')) return;
    card.setAttribute('data-pdp-ready', '');

    var video = card.querySelector('[data-fm-ugcv-video]');
    var toggle = card.querySelector('[data-fm-ugcv-toggle]');
    var sound = card.querySelector('[data-fm-ugcv-sound]');
    if (!video) return;

    if (coverIo) coverIo.observe(card); else loadCover(video);

    video.muted = false;
    card.classList.add('is-unmuted');
    card.classList.toggle('is-paused', video.paused);

    video.addEventListener('play', function () {
      card.classList.remove('is-paused');
      pauseOthers(card);
    });
    video.addEventListener('pause', function () { card.classList.add('is-paused'); });

    function fire() {
      if (reduceMotion) return;
      // A very short buzz on phones that support it, like the original.
      if (navigator.vibrate) { try { navigator.vibrate(14); } catch (e) {} }
      card.classList.remove('is-firing');
      void card.offsetWidth;
      card.classList.add('is-firing');
      setTimeout(function () { card.classList.remove('is-firing'); }, 650);
    }

    function start() {
      if (video.preload === 'none') video.preload = 'auto';
      video.muted = false;
      card.classList.add('is-unmuted');
      var p = video.play();
      if (!p || !p.catch) return;
      p.catch(function (err) {
        // The browser refused to start with sound: try once more muted.
        if (err && err.name === 'NotAllowedError') {
          video.muted = true;
          card.classList.remove('is-unmuted');
          var again = video.play();
          if (again && again.catch) again.catch(function () {});
        }
      });
    }

    // A card without a playable file (empty video setting in the editor) stays paused.
    function hasSource() {
      if (video.getAttribute('src')) return true;
      return [].some.call(video.querySelectorAll('source'), function (s) { return s.getAttribute('src'); });
    }

    function flip() {
      if (!hasSource()) return;
      if (video.paused) { fire(); start(); } else { video.pause(); }
    }

    if (toggle) toggle.addEventListener('click', flip);
    video.addEventListener('click', flip);

    if (sound) {
      sound.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        card.classList.toggle('is-unmuted', !video.muted);
      });
    }

    if (io) io.observe(card);
  }

  function boot() { document.querySelectorAll('[data-fm-ugcv-card]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
